/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * setMouseStalker.js
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";
import { ScrollToPlugin } from "gsap/dist/ScrollToPlugin";

//gsapのプラグインを登録
gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(ScrollToPlugin);

let mouseLock;
let option = { duration: 0.7, ease: "Expo.easeInOut", overwrite: true, }

/**
 * mouseStalker
 */
function mouseStalker() {
  mouseLock = false;
  let stalker, rect, pos, mouse, speed, xSet, ySet;

  //初期設定
  const init = () => {
    stalker = document.querySelector('.--js_setMouseStalker');
    rect = stalker.getBoundingClientRect();
    pos = { x: window.innerWidth / 2, y: window.innerHeight / 2 };
    mouse = { x: window.innerWidth / 2, y: window.innerHeight / 2 };
    speed = 0.15;
    xSet = gsap.quickSetter(stalker, "x", "px");
    ySet = gsap.quickSetter(stalker, "y", "px");
  }

  window.addEventListener("resize", () => { rect = stalker.getBoundingClientRect(); });

  //ポインターの初期設定
  const pointerProcess = (init = false) => {
    mouseLock = false;
    window.addEventListener("mousemove", (event) => {
      // const rectSize = 10;
      // mouse.x = event.x - rectSize / 2;
      // mouse.y = event.y - rectSize / 2;
      mouse.x = event.x - rect.width / 2;
      mouse.y = event.y - rect.width / 2;
    });
    if (init) {
      gsap.to(stalker, {
        scale: 1,
        ...option,
      });
    }
  }

  //ストーカー実装
  const setStalker = () => {
    gsap.ticker.add(() => {
      if (mouseLock === true) {
        return;
      }
      const dt = 1.0 - Math.pow(1.0 - speed, gsap.ticker.deltaRatio());
      pos.x += (mouse.x - pos.x) * dt;
      pos.y += (mouse.y - pos.y) * dt;
      xSet(pos.x);
      ySet(pos.y);
    });
  }

  //変形 - ボタン(blcok type)
  const stkTransform__btnBlock = (e) => {
    const rect = e.getBoundingClientRect();
    mouseLock = true;
    mouse.x = pos.x = rect.x;
    mouse.y = pos.y = rect.y;
    window.addEventListener("mousemove", (event) => {
      let center_x = event.x - rect.x - rect.width / 2;
      let center_y = event.y - rect.y - rect.height / 2;
      let x = center_x / (rect.width / 2) * -12;
      let y = center_y / (rect.height / 2) * -12;
      mouse.x = rect.x - x;
      mouse.y = rect.y - y;
    });
    gsap.to(stalker, {
      x: rect.x,
      y: rect.y,
      width: rect.width,
      height: rect.height,
      scale: 1,
      borderRadius: rect.width / 2,
      backgroundColor: "transparent",
      duration: 0.5,
      ease: "back.out",
      overwrite: true,
    });
  }

  //変形 - アンダーライン
  const stkTransform__underline = (e) => {
    mouseLock = true;
    const rect = e.getBoundingClientRect();
    mouse.x = pos.x = rect.x - 1;
    mouse.y = pos.y = rect.y - 1;
    gsap.to(stalker, {
      x: rect.x - 1,
      y: rect.height + rect.y - 1,
      width: rect.width,
      height: "1px",
      scale: 1,
      borderRadius: 0,
      duration: 0.5,
      ease: "back.out",
      overwrite: true,
    });
  }

  //変形 - 拡大
  const stkTransform__scale = (e, props) => {
    const rect = e.getBoundingClientRect();
    let propsType = {
      up: { width: rect.width * 1.2, height: rect.width * 1.2, scale: 1, borderRadius: rect.width * 1.2, backgroundColor: "transparent", },
      down: { scale: 0, duration: 1, }
    }
    window.addEventListener("mousemove", (event) => {
      let center_x = event.x - rect.width / 2;
      let center_y = event.y - rect.width / 2;
      if (props === "up") {
        mouse.x = center_x;
        mouse.y = center_y;
      }
    });
    gsap.to(stalker, {
      ...propsType[props],
      ...option,
    });
  }

  const stkTransform__about_cursor = () => {
    let cursor__apparel__area = document.querySelector('.apparel__area');
    let cursor__coffee_beer__area = document.querySelector('.coffee-beer__area');
    let cursor__apparel = document.querySelector('.cursor__apparel');
    let cursor__coffee_beer = document.querySelector('.cursor__coffee-beer');

    cursor__apparel__area.addEventListener('mouseenter', () => cursor__apparel.classList.add('--is-show'));
    cursor__apparel__area.addEventListener('mouseleave', () => cursor__apparel.classList.remove('--is-show'));
    cursor__coffee_beer__area.addEventListener('mouseenter', () => cursor__coffee_beer.classList.add('--is-show'));
    cursor__coffee_beer__area.addEventListener('mouseleave', () => cursor__coffee_beer.classList.remove('--is-show'));
  }

  //初期化
  window.addEventListener("load", () => {
    init();
    pointerProcess(true);
    setStalker();
    stkTransform__about_cursor();
  })
}

export { mouseStalker };